module.exports = __webpack_public_path__ + "img/wrong.aa5f3d09.png";